<template>
  <div id="transfer">
    <loading v-if="loadingRender"></loading>
    <net-pa-list-page-card
      title="فرم انتقال وجه"
      description="از طریق این فرم می‌توانید بین حساب خود و اعضای وابسته درخواست انتقال وجه خود را ثبت نمایید"
      :show-back="true"
    >
      <div class="Transfer-form-vertical py-3 px-0">
        <!-- بخش ۱: حساب مبدأ -->
        <div class="Transfer-section">
          <div class="Transfer-section-title">حساب مبدأ</div>
          <div class="Transfer-field">
            <label class="Transfer-label">انتخاب حساب</label>
            <select
              v-if="IsLoad"
              @change="cheangcmbTaahodat()"
              name="cmbTaahodat"
              id="cmbTaahodat"
              class="form-control Pointer"
              v-model="Resultcmb"
            >
              <option v-if="this.IsLoad == false" value="-2">
                || در حال بارگذاری ، منتظر بمانید ... ||
              </option>
              <option selected value="-1">-- انتخاب حساب --</option>
              <option
                v-for="item in this.ListModel"
                :key="item.id"
                :value="item"
              >
                <span>{{ item.vcodeDesNo }} </span>
                <span>{{ item.nameFamily }} </span>
              </option>
            </select>
          </div>
          <div
            v-if="Resultcmb != null && Resultcmb != '-1'"
            class="Transfer-field Transfer-balance"
          >
            <span class="text-muted"
              >موجودی:
              {{
                $Comma3ragham(
                  Number(this.Resultcmb.mande) +
                    Number(this.Resultcmb.sumMabTaeedNaShode),
                )
              }}</span
            >
            <span class="text-muted mr-3"
              >قابل برداشت:
              {{ $Comma3ragham(Number(this.Resultcmb.ghabelBardasht)) }}</span
            >
          </div>
        </div>

        <!-- بخش ۲: حساب مقصد -->
        <div class="Transfer-section">
          <div class="Transfer-section-title">حساب مقصد</div>
          <div class="Transfer-field">
            <label class="Transfer-label">نوع حساب مقصد</label>
            <ul
              class="nav nav-tabs Transfer-dest-tabs"
              role="tablist"
              dir="rtl"
            >
              <li class="nav-item">
                <button
                  type="button"
                  class="nav-link Transfer-dest-tab Transfer-dest-tab--self"
                  :class="{ active: transferDestType === 'self' }"
                  @click="setTransferDestType('self')"
                >
                  <i class="fas fa-user" aria-hidden="true"></i>
                  <span>حساب خود</span>
                </button>
              </li>
              <li class="nav-item">
                <button
                  type="button"
                  class="nav-link Transfer-dest-tab Transfer-dest-tab--others"
                  :class="{ active: transferDestType === 'others' }"
                  @click="setTransferDestType('others')"
                >
                  <i class="fas fa-users" aria-hidden="true"></i>
                  <span>حساب دیگران</span>
                </button>
              </li>
              <li class="nav-item">
                <button
                  type="button"
                  class="nav-link Transfer-dest-tab Transfer-dest-tab--saved"
                  :class="{ active: transferDestType === 'saved' }"
                  @click="setTransferDestType('saved')"
                >
                  <i class="fas fa-bookmark" aria-hidden="true"></i>
                  <span>حساب‌های ذخیره شده</span>
                </button>
              </li>
            </ul>
          </div>

          <div v-if="IsHesab == true" class="Transfer-field">
            <label class="Transfer-label">انتخاب حساب</label>
            <select
              name="cmbTaahodatDest"
              id="cmbTaahodatDest"
              class="form-control Pointer"
              v-model="Resultcmb2"
            >
              <option v-if="this.IsLoad2 == false" value="-2">
                || ... لطفا ابتدا حساب مبدأ را انتخاب نمایید ... ||
              </option>
              <option selected value="-1">-- انتخاب حساب --</option>
              <option
                v-for="item in this.ListModel2"
                :key="item.id"
                :value="item"
              >
                <span>{{ item.vcodeDesNo }} </span>
                <span>{{ item.nameFamily }} </span>
              </option>
            </select>
          </div>

          <div v-if="IsHesab == false" class="Transfer-field">
            <label class="Transfer-label">شماره حساب | تسهیلات</label>
            <div class="Transfer-vcode-row" dir="rtl">
              <input
                v-if="$session.get('CustCode') != '934'"
                autocomplete="off"
                class="form-control text-center Transfer-vcode-input"
                id="VCode"
                type="text"
                placeholder="شماره حساب | تسهیلات"
                v-model="VCode"
                v-mask="'###-##-#######'"
                dir="ltr"
              />
              <input
                v-else
                autocomplete="off"
                class="form-control text-center Transfer-vcode-input"
                id="VCode"
                type="text"
                placeholder="شماره حساب | تسهیلات"
                v-model="VCode"
                v-mask="'###-##-###########'"
                dir="ltr"
              />
              <button
                type="button"
                class="Transfer-vcode-check-btn"
                @click="CheckupVcode()"
                dir="ltr"
              >
                بررسی
              </button>
            </div>
          </div>

          <div
            v-if="IsHesab == false && Result != null"
            class="Transfer-field Transfer-info"
          >
            <span class="text-muted d-block"
              >مشخصات: {{ Result.nameFamily }}</span
            >
            <span class="text-muted d-block"
              >نوع حساب: {{ Result.desNoe }}</span
            >
            <span v-if="tblSarfaslTypeId" class="text-muted d-block"
              >مبلغ قابل پرداخت: {{ $Comma3ragham(sumGhabelPar) }}</span
            >
            <span v-if="tblSarfaslTypeId" class="text-muted d-block"
              >مبلغ جریمه: {{ $Comma3ragham(wwwJarime) }}</span
            >
          </div>

          <div v-if="IsHesab == false && Result != null" class="Transfer-field">
            <div class="custom-control custom-switch">
              <input
                type="checkbox"
                class="custom-control-input InputText"
                v-model="SaveHesab"
                id="SaveShebaOrCard"
              />
              <label class="custom-control-label Pointer" for="SaveShebaOrCard"
                >ذخیره اطلاعات حساب</label
              >
            </div>
          </div>

          <div
            v-if="SaveDetailHesab && ListSaveHesab.length > 0"
            class="Transfer-field"
          >
            <div class="BoxList">
              <div
                class="Transfer-saved-item"
                v-for="(item, key) in ListSaveHesab"
                :key="key"
              >
                <div class="Transfer-saved-info">
                  <span class="Transfer-label d-block mb-1"
                    >حساب | تسهیلات</span
                  >
                  <span>{{ item.shebaOrCardNum }}</span>
                  <span class="Transfer-label d-block mb-1 mt-2"
                    >نام صاحب حساب</span
                  >
                  <span>{{ item.sahebShebaOrCard }}</span>
                </div>
                <div class="Transfer-saved-actions">
                  <span
                    v-if="item.selected != true"
                    class="Pointer"
                    @click="SelectSaveHesab(item.id)"
                    title="انتخاب"
                    ><i class="fa fa-check"></i
                  ></span>
                  <span v-else class="Pointer text-success" title="انتخاب شده"
                    ><i class="fa fa-check"></i
                  ></span>
                  <span
                    class="Pointer ml-3"
                    @click="RemoveShebeOrCard(item)"
                    title="حذف"
                    ><i class="fa fa-trash text-muted"></i
                  ></span>
                </div>
              </div>
            </div>
          </div>

          <div
            v-if="Resultcmb2 != null && Resultcmb2 != '-1'"
            class="Transfer-field Transfer-balance"
          >
            <span class="text-muted"
              >موجودی:
              {{
                $Comma3ragham(
                  Number(this.Resultcmb2.mande) +
                    Number(this.Resultcmb2.sumMabTaeedNaShode),
                )
              }}</span
            >
            <span class="text-muted mr-3"
              >قابل برداشت:
              {{ $Comma3ragham(Number(this.Resultcmb2.ghabelBardasht)) }}</span
            >
          </div>
        </div>

        <!-- بخش ۳: مبلغ -->
        <div class="Transfer-section">
          <div class="Transfer-section-title">مبلغ انتقال</div>
          <div class="Transfer-field">
            <label class="Transfer-label">مبلغ</label>
            <input
              ref="txtMablagh"
              id="txtMablagh"
              tabindex="1"
              class="form-control 3ragham text-center"
              v-model="txtMablagh"
              @keypress="$ValidNumber($event, 11)"
            />
          </div>
          <div class="Transfer-field">
            <label class="Transfer-label">توضیحات (اختیاری)</label>
            <textarea
              class="form-control text-right"
              placeholder="توضیحات"
              rows="3"
              v-model="Description"
            ></textarea>
          </div>
        </div>

        <!-- کپچا و دکمه -->
        <div class="Transfer-section">
          <div class="Transfer-field">
            <CaptchaBox ref="captchaRef" @update="onCaptchaValid"></CaptchaBox>
          </div>
          <div v-if="!twoLevel" class="Transfer-field text-center mt-3">
            <button
              :disabled="!CaptchaValid"
              class="btn btn-warning btn-lg px-5"
              @click="checkSms()"
            >
              {{ GetMablagh }}
            </button>
          </div>
        </div>

        <!-- دو مرحله‌ای -->
        <div v-if="twoLevel == true" class="Transfer-section">
          <div class="Transfer-field">
            <label class="Transfer-label">رمز پیامک شده را وارد کنید</label>
            <div class="row align-items-end">
              <div class="col">
                <input
                  v-model="twstepCode"
                  type="number"
                  class="form-control text-center"
                />
              </div>
              <div class="col-auto mt-2 mt-md-0">
                <button @click="CheckCode" class="btn btn-success px-4">
                  تایید
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </net-pa-list-page-card>
  </div>
</template>
<script>
import NetPaListPageCard from "../Tools/NetPa/NetPaListPageCard.vue";
import loading from "../Tools/NetPa/Loading.vue";
import CaptchaBox from "../CmpLogin/CaptchaBox.vue";

export default {
  components: {
    NetPaListPageCard,
    loading,
    CaptchaBox,
  },
  data() {
    return {
      captchaText: "",
      captchaId: "",
      CaptchaValid: false,
      twstepCode: "",
      twoLevel: false,
      KEY: 0,
      ListSaveHesab: [],
      SaveDetailHesab: false,
      SaveHesab: false,
      DataAxios_Variz: {
        ArryfildValue: {},
        Method: "Post",
        Action: "VarizGorohi/SetVarizGorohi",
        Token: this.$session.get("TokenNetPa"),
      },
      DataAxios_cmbTaahodat: {
        ArryfildValue: "",
        Method: "Post",
        Action: "ListTaahodat",
        Token: this.$session.get("TokenNetPa"),
      },
      DataAxios_SahebHesab: {
        ArryfildValue: "",
        Method: "Post",
        Action: "ListTaahodat/TaahodatSahebHesab",
        Token: this.$session.get("TokenNetPa"),
      },
      DataAxios_Enteghal: {
        ArryfildValue: "",
        Method: "Post",
        Action: "EnteghalVajh",
        Token: this.$session.get("TokenNetPa"),
      },
      DataAxiosRowVCode: {
        ArryfildValue: "",
        Method: "Post",
        Action: "TaahodatByVCNew",
        Token: this.$session.get("TokenNetPa"),
      },
      Description: "",
      IsLoad: false,
      Resultcmb: null,
      loadingRender: false,
      ListModel: null,
      ListModelSahebHesab: null,
      IsLoad2: false,
      ListModel2: null,
      ListModelSahebHesab2: null,
      Resultcmb2: null,
      txtMablagh: 0,
      IsHesab: true,
      transferDestType: "self",
      VCode: "",
      Result: null,
      wwwJarime: 0,
      sumGhabelPar: 0,
      tblSarfaslTypeId: false,
      MabFormulaJarime: 0,
      WwwtblAzaId: null,
      BnpCashDBtblTaahodatId: null,
      BnpCashDBtblAzaId: null,
    };
  },
  mounted() {
    this.GetData();
  },
  updated() {
    this.$PutCommatoInput();
  },
  methods: {
    onCaptchaValid({ valid, captchaId, userInput }) {
      this.CaptchaValid = valid;
      this.captchaId = captchaId;
      this.captchaText = userInput;
    },
    refreshCaptcha() {
      this.$refs.captchaRef.generateCaptcha();
    },
    GetData() {
      const formData = new FormData();
      let info;
      formData.append(
        "wwwtblAzaId",
        this.$session.get("UserInfoNetPa").wwwtblAzaId,
      );
      formData.append("wwwtblSarfaslTypeId", 2);
      this.DataAxios_cmbTaahodat.ArryfildValue = formData;
      this.$PostFormData(this.DataAxios_cmbTaahodat)
        .then((data) => {
          this.IsLoad = true;
          this.ListModel = data.filter((x) => x.tblSarfaslTypeId != 6);
          console.log(this.ListModel);
          console.log(data);
          this.Resultcmb = "-1";
        })
        .finally(() => {
          const formData = new FormData();
          formData.append(
            "wwwtblAzaId",
            this.$session.get("UserInfoNetPa").wwwtblAzaId,
          );
          formData.append("wwwtblSarfaslTypeId", 2);
          this.DataAxios_SahebHesab.ArryfildValue = formData;
          this.$PostFormData(this.DataAxios_SahebHesab).then((data) => {
            if (data.length > 0) {
              this.IsLoad = true;
              this.ListModelSahebHesab = data;
              for (
                let index = 0;
                index < this.ListModelSahebHesab.length;
                index++
              ) {
                if (this.ListModelSahebHesab[index].hasHaghEmza == true) {
                  info = this.ListModelSahebHesab[index];
                  this.ListModel.push(info);
                }
              }
            }
          });
        });
    },
    setTransferDestType(type) {
      this.transferDestType = type;
      if (type === "self") {
        this.ShowHesab(true);
        this.SaveDetailHesab = false;
      } else if (type === "others") {
        this.ShowHesab(false);
        this.SaveDetailHesab = false;
      } else if (type === "saved") {
        this.SaveDetailHesab = true;
        this.IsHesab = null;
        this.GetDataShebaOrCard();
      }
    },
    ShowHesab(status) {
      this.IsHesab = status;
      if (!status) {
        this.Result = null;
      }
    },
    CheckupVcode() {
      if (this.VCode != "") {
        this.loadingRender = true;
        this.Shenase = "";
        const formData = new FormData();
        formData.append("VCode", this.$Encryption(this.VCode));
        this.DataAxiosRowVCode.ArryfildValue = formData;

        this.$PostFormData(this.DataAxiosRowVCode).then((data) => {
          if (data != null) {
            //Maghsad
            this.Result = data;
            this.Resultcmb2 = null;
            this.loadingRender = false;
            if (data.tblSarfaslTypeId == 1) {
              // console.log('data*/*/*',data);
              this.tblSarfaslTypeId = true;
              this.sumGhabelPar = data.sumGhabelPar;

              this.wwwJarime = data.wwwJarime;
              this.txtMablagh = this.$Comma3ragham(data.sumGhabelPar);

              this.WwwtblAzaId = data.wwwtblAzaId;
              this.BnpCashDBtblTaahodatId = data.bnpCashDBtblTaahodatId;
              this.BnpCashDBtblAzaId = data.bnpCashDBtblAzaId;
            } else {
              this.tblSarfaslTypeId = false;
              this.sumGhabelPar = 0;
              this.wwwJarime = 0;
              this.txtMablagh = 0;
            }
          } else {
            this.$mySweetDefaultTost(
              "خطا",
              "شماره حساب وارد شده صحیح نمی باشد .",
              "error",
              2500,
            );
            this.Result = null;
            this.loadingRender = false;
          }
        });
      } else {
        this.$mySweetDefault(
          "خطا",
          "شماره حساب نمی تواند خالی می باشد ",
          "error",
          2500,
        );
        this.Result = null;
      }
    },
    cheangcmbTaahodat() {
      if (this.Resultcmb != undefined || this.Resultcmb.id != "-1") {
        const formData = new FormData();
        let info;
        formData.append(
          "wwwtblAzaId",
          this.$session.get("UserInfoNetPa").wwwtblAzaId,
        );
        formData.append("wwwtblSarfaslTypeId", 2);
        this.DataAxios_cmbTaahodat.ArryfildValue = formData;
        this.$PostFormData(this.DataAxios_cmbTaahodat)
          .then((data) => {
            this.IsLoad2 = true;
            this.ListModel2 = data.filter(
              (x) => x.id != this.Resultcmb.id && x.tblSarfaslTypeId != 6,
            );
          })
          .finally(() => {
            const formData = new FormData();
            formData.append(
              "wwwtblAzaId",
              this.$session.get("UserInfoNetPa").wwwtblAzaId,
            );
            formData.append("wwwtblSarfaslTypeId", 2);
            this.DataAxios_SahebHesab.ArryfildValue = formData;
            this.$PostFormData(this.DataAxios_SahebHesab).then((data) => {
              if (data.length > 0) {
                this.IsLoad2 = true;
                this.ListModelSahebHesab2 = data.filter(
                  (x) => x.id != this.Resultcmb.id,
                );
                for (
                  let index = 0;
                  index < this.ListModelSahebHesab2.length;
                  index++
                ) {
                  info = this.ListModelSahebHesab2[index];
                  this.ListModel2.push(info);
                }
              }
            });
          });
      }
    },

    checkSms() {
      if (
        this.$session.get("CustCode") == "801" ||
        this.$session.get("CustCode") == "255"
      ) {
        this.sendTwoStepCode();
      } else this.SabtEnteghal();
    },
    sendTwoStepCode() {
      this.twoLevel = true;
      var DataAxiosSms = {
        Method: "GET",
        Token: this.$session.get("TokenNetPa"),
        Action:
          "twoStepVerification?wwwtblAzaId=" +
          this.$session.get("UserInfoNetPa").wwwtblAzaId,
        ArryfildValue: null,
      };
      this.$PostData(DataAxiosSms).then((result) => {
        if (result.status == "success") {
          this.$mySweetDefaultTost("", result.msg, "success", 2800);
        }
      });
    },
    CheckCode() {
      var DataAxiosCheckCode = {
        Method: "POST",
        Token: this.$session.get("TokenNetPa"),
        Action: "twoStepVerification",
        ArryfildValue: {
          wwwtblAzaId: this.$session.get("UserInfoNetPa").wwwtblAzaId,
          Code: this.twstepCode + "",
        },
      };
      this.$PostData(DataAxiosCheckCode).then((result) => {
        if (result.status) {
          this.SabtEnteghal();
        } else {
          this.$mySweetDefaultTost(
            "خطا",
            "رمز دو مرحله ای وارد شده صحیح نمیباشد. دوباره تلاش کنید",
            "error",
            2800,
          );
          this.refreshCaptcha();
        }
      });
    },

    SabtEnteghal() {
      if (this.txtMablagh <= 0) {
        this.$mySweetDefaultTost(
          "عدم ورود مبلغ صحیح",
          "مبلغ انتقال وجه صفر یا وارد نشده است",
          "warning",
          3000,
        );
        this.refreshCaptcha();
      } else {
        if (
          this.Resultcmb == null ||
          (this.Resultcmb2 == null && this.Result == null)
        ) {
          this.$mySweetDefaultTost(
            "عدم انتخاب حساب",
            "حساب مبداء یا مقصد انتخاب نشده است",
            "warning",
            3000,
          );
          this.refreshCaptcha();
        } else {
          if (
            Number(this.txtMablagh.replaceAll(/,/g, "")) <
            Number(this.sumGhabelPar)
          ) {
            var MablaghJarime = this.wwwJarime > 0 ? this.wwwJarime : 0;
            if (this.$session.get("CustCode") == 561) {
              this.MabFormulaJarime =
                (Number(this.txtMablagh.replaceAll(/,/g, "")) /
                  Number(this.sumGhabelPar)) *
                MablaghJarime;
            } else {
              this.MabFormulaJarime =
                (Number(this.txtMablagh.replaceAll(/,/g, "")) /
                  (Number(this.sumGhabelPar) - MablaghJarime)) *
                MablaghJarime;
            }
            // console.log(this.MabFormulaJarime);
          } else {
            this.MabFormulaJarime = this.wwwJarime > 0 ? this.wwwJarime : 0;
            // console.log(this.MabFormulaJarime);
          }
          let ghabelBardasht = Number(this.Resultcmb.ghabelBardasht);
          let MablaghEnteghal = Number(this.txtMablagh.replaceAll(",", ""));

          if (MablaghEnteghal <= ghabelBardasht) {
            //Checkup Mahdodiyat enteghal dar roz
            if (MablaghEnteghal < 10000) {
              this.$mySweetDefaultTost(
                "مبلغ انتقال نا درست",
                " مبلغ انتقال نمیتواند کمتر از 10,000" +
                  this.$GetVahedPool() +
                  "باشد",
                "warning",
                3000,
              );
              this.refreshCaptcha();
            } else {
              this.ChekMojavez(
                this.Resultcmb.id,
                this.txtMablagh.replaceAll(",", ""),
              );
            }
            //................................................................
          } else {
            this.$mySweetDefaultTost(
              "عدم انتقال وجه",
              " مبـلـغ وارد شده بیشـتر از مبلغ قابل برداشت  حسـاب " +
                this.Resultcmb.desNoe +
                " میباشد ",
              "warning",
              3000,
            );
            this.refreshCaptcha();
          }
        }
      }
    },
    ChekMojavez(wwwtblTaahodatId, Amount) {
      var DataAxios_Check = {
        ArryfildValue: "",
        Method: "Post",
        Action: "TanzimatNoe/ChekMojavez",
        Token: this.$session.get("TokenNetPa"),
      };
      const formData = new FormData();
      formData.append("wwwtblTaahodatId", wwwtblTaahodatId);
      formData.append("Amount", Amount);
      formData.append("IsBardasht", false);
      DataAxios_Check.ArryfildValue = formData;
      this.$PostFormData(DataAxios_Check).then((data) => {
        if (data.status == "Ok") {
          if (data.data[0].isMojaz == 1) {
            // console.log(this.Resultcmb2);
            let result;
            if (this.Resultcmb2 != null) {
              result = this.Resultcmb2;
              // result['nameFamily']=this.$session.get('UserInfoNetPa').ozvName + ' ' + this.$session.get('UserInfoNetPa').ozvFamily
              result["nameFamily"] = " ";
            } else {
              result = this.Result;
            }
            this.$SweetQustion(
              "اطمینان از انتقال وجه",
              " از انتقال وجه به مبلغ " +
                this.$Comma3ragham(Number(Amount.replace(/,/g, ""))) +
                this.$GetVahedPool() +
                " به شماره حساب | شماره تسهیلات " +
                this.$b_InvertCode(result.vCode, "-") +
                " _ " +
                result.desNoe +
                "  به نام آقا | خانم " +
                " [ " +
                result.nameFamily +
                " ] " +
                " اطمینان دارید ؟ ",
              "question",
              "تایید و انتقال",
              "انصراف",
              null,
              this.Enteghal,
              this.Cancel,
            );
          } else {
            this.$mySweetDefaultTost(
              "محدودیت انتقال روزانه",
              "  سقف انتقال وجه شما در امروز به پایان رسیده و یا مبلغ وارد شده بیشتر از حد مجاز روزانه" +
                " ( " +
                this.$Comma3ragham(data.data[0].maxEnteghal) +
                " ) " +
                this.$GetVahedPool() +
                " می باشد",
              "error",
              3500,
            );
            this.refreshCaptcha();
          }
        } else {
          this.$mySweetDefaultTost(
            "خطایی رخ داده",
            "در انتقال وجه خطایی رخ داده لفا کمی بعد دوباره تلاش فرمایید",
            "error",
            3500,
          );
          this.refreshCaptcha();
        }
      });
    },
    Enteghal() {
      if (this.SaveHesab == true) {
        this.SaveDataShebaOrCard().then((data) => {
          if (data == true) {
            this.$mySweetDefaultTost(
              "عملیات موفق",
              "ذخیره اطلاعات حساب | تسهیلات با موفقیت انجام گردید",
              "success",
              2000,
            );
          } else {
            this.$mySweetDefaultTost(
              "عملیات ناموفق",
              "ذخیره اطلاعات حساب | تسهیلات با خطا روبه رو شد",
              "danger",
              2000,
            );
          }
        });
      }
      //// کدهای ثبت واریز گروهی
      const WwwtblVarizGorohiRiz = [];
      if (this.tblSarfaslTypeId == true) {
        /*wwwtblTaahodatIdBestanKar*/
        WwwtblVarizGorohiRiz.push({
          WwwtblTaahodatId:
            this.Result != null ? this.Result.id : this.Resultcmb2.id,
          Mablagh: Number(this.txtMablagh.replaceAll(/,/g, "")),
          SharhRiz: "واریز به حساب / تسهیلات ",
          WwwtblAzaId: this.WwwtblAzaId,
          BnpCashDBtblTaahodatId: this.BnpCashDBtblTaahodatId,
          BnpCashDBtblAzaId: this.BnpCashDBtblAzaId,
          MablaghJarime: this.wwwJarime,
          TarixGhest: "",
          IsTaahodatRiz: false,
        });
        /*wwwtblTaahodatIdBestanKar*/

        this.DataAxios_Variz.ArryfildValue.Mablagh = Number(
          this.txtMablagh.replaceAll(/,/g, ""),
        );
        this.DataAxios_Variz.ArryfildValue.CodeRahgiri = 0;
        this.DataAxios_Variz.ArryfildValue.Tarix = this.$store.state.JalaliDate;
        this.DataAxios_Variz.ArryfildValue.Sharh = " انتقال وجه ";
        this.DataAxios_Variz.ArryfildValue.ZamanInsert =
          this.$store.state.JalaliDate;
        this.DataAxios_Variz.ArryfildValue.CustCode = Number(
          this.$session.get("UserInfoNetPa").custCode,
        );
        this.DataAxios_Variz.ArryfildValue.tblComboIdVaziatGrp312 = 5538;
        this.DataAxios_Variz.ArryfildValue.wwwtblAzaId =
          this.$session.get("UserInfoNetPa").wwwtblAzaId;
        this.DataAxios_Variz.ArryfildValue.StatusVariz = 2;
        this.DataAxios_Variz.ArryfildValue.WwwtblVarizGorohiRiz =
          WwwtblVarizGorohiRiz;
        this.$PostData(this.DataAxios_Variz).then((result) => {
          if (result.status === "Success") {
            ////کدهای ثبت انتقال وجه
            const formData = new FormData();
            if (this.Result != null) {
              formData.append("wwwtblTaahodatIdBestanKar", this.Result.id);
            } else {
              formData.append("wwwtblTaahodatIdBestanKar", this.Resultcmb2.id);
            }
            formData.append("wwwtblTaahodatIdBedehKar", this.Resultcmb.id);
            formData.append("Mablagh", this.txtMablagh);
            formData.append("Desc", this.Description);
            formData.append("KodRahgiri", "");
            formData.append("CardNo", "");
            formData.append("ShebaNo", "");
            formData.append(
              "NameSahebHesab",
              this.$session.get("UserInfoNetPa").ozvName +
                " " +
                this.$session.get("UserInfoNetPa").ozvFamily,
            );
            formData.append("EnteghalNoe", 2);
            formData.append("HesabNo", "");
            formData.append("OrderId", "-2");
            formData.append("MabKarmozdEnteghal", 0);
            formData.append("MabKarmozdBnp", 0);
            formData.append("BankName", "");
            formData.append("ComboIdGrp324", 0);
            formData.append("TarixSanad", this.$store.state.JalaliDate);
            formData.append("VarizGorohiId", result.idRepoMaster);
            formData.append("wwwJarime", this.MabFormulaJarime);
            formData.append("userInput", this.captchaText);
            formData.append("captchaId", this.captchaId);
            this.DataAxios_Enteghal.ArryfildValue = formData;
            this.$PostFormData(this.DataAxios_Enteghal).then((data) => {
              if (data.id > 0 && data.success == "SUCCESS") {
                this.$mySweetDefaultTost(
                  "انتقال موفق",
                  "انتقال وجه با موفقیت انجام شد کد رهگیری : " +
                    data.codeRahgiri,
                  "success",
                  6000,
                );
                Object.assign(this.$data, this.$options.data.call(this));
                this.GetData();
                this.refreshCaptcha();
              } else {
                this.$mySweetDefaultTost(
                  "مشکل در انتقال وجه",
                  "مشکلی در انتقال وجه پیش آمده لطفا مجددا تلاش کنید",
                  "warning",
                  3000,
                );
                this.refreshCaptcha();
              }
            });

            ////کدهای ثبت انتقال وجه
          }
        });
      } else {
        ////کدهای ثبت انتقال وجه
        const formData = new FormData();
        formData.append(
          "wwwtblAzaId",
          this.$session.get("UserInfoNetPa").wwwtblAzaId,
        );
        if (this.Result != null) {
          formData.append("wwwtblTaahodatIdBestanKar", this.Result.id);
        } else {
          formData.append("wwwtblTaahodatIdBestanKar", this.Resultcmb2.id);
        }
        formData.append("wwwtblTaahodatIdBedehKar", this.Resultcmb.id);
        formData.append("Mablagh", this.txtMablagh);
        formData.append("Desc", this.Description);
        formData.append("KodRahgiri", "");
        formData.append("CardNo", "");
        formData.append("ShebaNo", "");
        formData.append(
          "NameSahebHesab",
          this.$session.get("UserInfoNetPa").ozvName +
            " " +
            this.$session.get("UserInfoNetPa").ozvFamily,
        );
        formData.append("EnteghalNoe", 2);
        formData.append("HesabNo", "");
        formData.append("OrderId", "-2");
        formData.append("MabKarmozdEnteghal", 0);
        formData.append("MabKarmozdBnp", 0);
        formData.append("BankName", "");
        formData.append("ComboIdGrp324", 0);
        formData.append("TarixSanad", this.$store.state.JalaliDate);
        formData.append("VarizGorohiId", 0);
        formData.append("wwwJarime", this.MabFormulaJarime);
        formData.append("userInput", this.captchaText);
        formData.append("captchaId", this.captchaId);
        this.DataAxios_Enteghal.ArryfildValue = formData;
        this.$PostFormData(this.DataAxios_Enteghal).then((data) => {
          if (data.id > 0 && data.success == "SUCCESS") {
            this.$mySweetDefaultTost(
              "انتقال موفق",
              "انتقال وجه با موفقیت انجام شد کد رهگیری : " + data.codeRahgiri,
              "success",
              6000,
            );
            Object.assign(this.$data, this.$options.data.call(this));
            this.GetData();
            this.refreshCaptcha();
          } else {
            this.$mySweetDefaultTost(
              "مشکل در انتقال وجه",
              "مشکلی در انتقال وجه پیش آمده لطفا مجددا تلاش کنید",
              "warning",
              3000,
            );
            this.refreshCaptcha();
          }
        });

        ////کدهای ثبت انتقال وجه
      }
    },
    SaveDataShebaOrCard() {
      return new Promise((success, reject) => {
        let Data = {
          Id: 0,
          wwwtblAzaId: this.$session.get("UserInfoNetPa").wwwtblAzaId,
          IsSheba: false,
          SahebShebaOrCard: this.Result.nameFamily + " _ " + this.Result.desNoe,
          ShebaOrCardNum: this.Result.vCode,
          IsBardasht: false,
        };
        var DataAxiosFindShebaOrCard = {
          ArryfildValue: Data,
          Method: "Post",
          Action: "ShebaOrCard",
          Token: this.$session.get("TokenNetPa"),
        };
        this.$PostData(DataAxiosFindShebaOrCard).then((data) => {
          if (data.status == "Success") {
            success(true);
          }
          // else if(data.status == 'Dup') {
          //   //اطلاعات شبا و یا کارت تکراری بوده
          // }
          else {
            //خطا در ذخیره
          }
        });
      });
    },
    Cancel() {},
    GetDataShebaOrCard() {
      var DataAxios = {
        ArryfildValue: "",
        Method: "post",
        Action: "ShebaOrCard/GetShebaOrCard",
        Token: this.$session.get("TokenNetPa"),
      };
      const formData = new FormData();
      formData.append(
        "wwwtblAzaId",
        this.$session.get("UserInfoNetPa").wwwtblAzaId,
      );
      DataAxios.ArryfildValue = formData;
      this.$PostFormData(DataAxios).then((data) => {
        data.forEach((value) => {
          value["select"] = false;
        });
        this.ListSaveHesab = data.filter((x) => x.isBardasht == false);
        this.KEY++;
      });
    },
    SelectSaveHesab(id) {
      this.ListSaveHesab.forEach((el) => {
        if (el.id == id) {
          el.selected = true;
          this.ShebaNo = el.shebaOrCardNum;
          this.NameSahebHesab = el.sahebShebaOrCard;
          this.VCode = el.shebaOrCardNum;
          this.CheckupVcode();
          this.KEY++;
        } else {
          el.selected = false;
        }
      });

      this.SaveDetailHesab = false;
      this.IsHesab = false;
      this.transferDestType = "others";
    },
    RemoveShebeOrCard(row) {
      this.$SweetQustion(
        "اطمینان ازحذف",
        " از حذف شماره حساب و یا تسهیلات " +
          row.shebaOrCardNum +
          " به نام  " +
          row.sahebShebaOrCard +
          " اطمینان دارید ؟ ",
        "question",
        "تایید حذف",
        "انصراف",
        row.id,
        this.ConfirmRemoveShebaOrCard,
        this.isNotConfirmed,
      );
    },
    ConfirmRemoveShebaOrCard(id) {
      var DataAxios = {
        ArryfildValue: "",
        Method: "Post",
        Action: "ShebaOrCard/DeleteShebaOrCard",
        Token: this.$session.get("TokenNetPa"),
      };
      const formData = new FormData();
      formData.append("wwwtbShebaOrCardId", id);
      DataAxios.ArryfildValue = formData;
      this.$PostFormData(DataAxios).then((data) => {
        if (data.status == "Success") {
          this.GetDataShebaOrCard();
          this.KEY++;
          this.$mySweetDefaultTost(
            "حذف موفق",
            " حذف شماره شبا یا شماره کارت انتخابی شما با موفقیت انجام شد",
            "success",
            2000,
          );
        }
      });
    },
    isNotConfirmed() {},
  },
  computed: {
    GetMablagh() {
      return (
        " انتقال  " + this.$Comma3ragham(this.txtMablagh) + this.$GetVahedPool()
      );
    },
  },
};
</script>
<style scoped>
.Transfer-form-vertical {
  max-width: 600px;
  margin: 0 auto;
}
.Transfer-section {
  margin-bottom: 1.75rem;
}
.Transfer-section-title {
  font-size: 1rem;
  font-weight: 600;
  color: #495057;
  margin-bottom: 0.75rem;
  padding-bottom: 0.35rem;
  border-bottom: 1px solid #dee2e6;
}
.Transfer-field {
  margin-bottom: 1rem;
}
.Transfer-field:last-child {
  margin-bottom: 0;
}
.Transfer-label {
  display: block;
  font-size: 0.875rem;
  color: #6c757d;
  margin-bottom: 0.35rem;
}
.Transfer-balance {
  font-size: 0.875rem;
}
.Transfer-info {
  font-size: 0.875rem;
  line-height: 1.6;
}
.Transfer-dest-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  width: 100%;
  margin: 0;
  padding: 4px;
  border: 1px solid #e8ecf1;
  border-radius: 12px;
  background: #f0f2f5;
  box-shadow: inset 0 1px 2px rgba(42, 63, 84, 0.04);
}

.Transfer-dest-tabs .nav-item {
  flex: 1 1 0;
  min-width: 0;
  margin-bottom: 0;
}

.Transfer-dest-tab {
  display: flex !important;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  min-height: 42px;
  padding: 0.5rem 0.65rem;
  border: none !important;
  border-radius: 9px;
  background: transparent;
  color: #6c757d;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.3;
  text-align: center;
  cursor: pointer;
  box-shadow: none;
  transition: background 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;
}

.Transfer-dest-tab i {
  flex: 0 0 auto;
  font-size: 15px;
}

.Transfer-dest-tab span {
  flex: 0 1 auto;
  min-width: 0;
}

.Transfer-dest-tab:hover:not(.active) {
  background: rgba(42, 63, 84, 0.06);
  color: #2a3f54;
}

.Transfer-dest-tab.active {
  color: #fff;
  box-shadow: 0 2px 8px rgba(42, 63, 84, 0.16);
}

.Transfer-dest-tab--self.active {
  background: #435ebe;
}

.Transfer-dest-tab--others.active {
  background: #f89215;
}

.Transfer-dest-tab--saved.active {
  background: #67b221;
}

.Transfer-dest-tab:focus {
  outline: none;
}

.Transfer-dest-tab:focus-visible {
  outline: 2px solid rgba(42, 63, 84, 0.35);
  outline-offset: 2px;
}

@media (max-width: 575px) {
  .Transfer-dest-tabs .nav-item {
    flex: 1 1 100%;
  }
}
.Transfer-saved-item {
  padding: 0.75rem 1rem;
  margin-bottom: 0.5rem;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  background: #fafafa;
}
.Transfer-saved-item:last-child {
  margin-bottom: 0;
}
.Transfer-saved-actions {
  margin-top: 0.5rem;
  padding-top: 0.5rem;
  border-top: 1px solid #eee;
  text-align: center;
}
.BoxList {
  max-height: 30vh;
  overflow-y: auto;
}
.Transfer-vcode-row {
  display: flex;
  align-items: stretch;
  gap: 0.5rem;
}
.Transfer-vcode-input {
  flex: 1 1 auto;
  min-width: 0;
  min-height: 42px;
  border: 1px solid #dce1e8;
  border-radius: 8px;
  font-size: 14px;
  box-shadow: none;
}
.Transfer-vcode-input:focus {
  border-color: #2a3f54;
  box-shadow: 0 0 0 2px rgba(42, 63, 84, 0.12);
}
.Transfer-vcode-check-btn {
  flex: 0 0 auto;
  min-width: 4.75rem;
  padding: 0 1rem;
  border: none;
  border-radius: 8px;
  background: #d48806;
  color: #fff;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.25;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  transition: background 0.15s ease;
}
.Transfer-vcode-check-btn:hover {
  background: #b87405;
}
.Transfer-vcode-check-btn:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(212, 136, 6, 0.35);
}
@media (max-width: 575px) {
  .Transfer-vcode-row {
    flex-direction: column;
  }
  .Transfer-vcode-check-btn {
    width: 100%;
    min-height: 42px;
  }
}
</style>
